// Modal quản lý danh mục kênh cộng đồng: mỗi dòng gồm icon (upload được,
// hiển thị trên chip #hashtag ở app/web) + tên danh mục + nút xoá.
import React, { useEffect, useState } from "react";
import { Modal, Input, message, Alert, Button, Upload, Avatar } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faImage } from "@fortawesome/free-solid-svg-icons";
import communityApi from "../../../api/communityApi";

const API_IMG_URL = process.env.REACT_APP_API_PUBLIC_URL || "";
const iconUrl = (icon) => `${API_IMG_URL}/img/community-icons/${icon}`;

export default function CommunityCategoriesModal({ open, onClose, onSaved }) {
    const [rows, setRows] = useState([]); // [{ id, name, icon }]
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                setLoading(true);
                const { data } = await communityApi.getCategories();
                // Tương thích data cũ dạng string
                const list = (data?.categories || []).map((c) =>
                    // PHẢI giữ id: máy chủ dựa vào nó để biết đây là ĐỔI TÊN chứ không
                    // phải xoá cũ + thêm mới. Mất id là người theo dõi thành mồ côi.
                    typeof c === "string"
                        ? { id: null, name: c, icon: null }
                        : { id: c.id ?? null, name: c.name, icon: c.icon || null }
                );
                setRows(list.length ? list : [{ name: "", icon: null }]);
            } catch {
                message.error("Không thể tải danh mục");
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    const updateRow = (index, patch) =>
        setRows((prev) => prev.map((r, i) => (i === index ? { ...r, ...patch } : r)));

    const handleUploadIcon = async (index, file) => {
        try {
            const { data } = await communityApi.uploadCategoryIcon(file);
            updateRow(index, { icon: data?.filename || null });
            message.success("Đã tải icon");
        } catch (error) {
            message.error(error.response?.data?.message || "Không thể tải icon");
        }
        return false; // chặn antd tự upload
    };

    const handleSave = async () => {
        const categories = rows
            .map((r) => ({ id: r.id ?? null, name: (r.name || "").trim(), icon: r.icon || null }))
            .filter((r) => r.name);
        if (categories.length === 0) {
            message.error("Cần ít nhất 1 danh mục");
            return;
        }
        try {
            setSaving(true);
            const { data } = await communityApi.updateCategories(categories);
            message.success(`Đã lưu ${categories.length} danh mục`);
            onSaved?.(data?.categories || categories);
            onClose();
        } catch (error) {
            message.error(error.response?.data?.message || "Không thể lưu danh mục");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Danh mục kênh cộng đồng"
            open={open}
            onOk={handleSave}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Đóng"
            confirmLoading={saving}
        >
            <Alert
                type="info"
                showIcon
                className="mb-3"
                message="Icon hiển thị trên chip #hashtag ở app/web (ảnh vuông, tự resize 128px). Đổi tên/xoá danh mục KHÔNG tự cập nhật bài cũ."
            />
            <div className="flex flex-col gap-2 max-h-[50vh] overflow-y-auto pr-1">
                {rows.map((row, index) => (
                    <div key={index} className="flex items-center gap-2">
                        <Upload
                            accept="image/jpeg,image/png,image/webp"
                            showUploadList={false}
                            beforeUpload={(file) => handleUploadIcon(index, file)}
                            disabled={loading}
                        >
                            <Button
                                shape="circle"
                                title="Tải icon danh mục"
                                icon={
                                    row.icon ? (
                                        <Avatar size={22} src={iconUrl(row.icon)} />
                                    ) : (
                                        <FontAwesomeIcon icon={faImage} className="text-content-3" />
                                    )
                                }
                            />
                        </Upload>
                        <Input
                            value={row.name}
                            onChange={(e) => updateRow(index, { name: e.target.value })}
                            placeholder="Tên danh mục, VD: Deal Shopee"
                            disabled={loading}
                        />
                        <Button
                            danger
                            type="text"
                            icon={<FontAwesomeIcon icon={faTrash} />}
                            onClick={() => setRows((prev) => prev.filter((_, i) => i !== index))}
                        />
                    </div>
                ))}
            </div>
            <Button
                type="dashed"
                block
                className="mt-3"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => setRows((prev) => [...prev, { id: null, name: "", icon: null }])}
            >
                Thêm danh mục
            </Button>
        </Modal>
    );
}
